import HandWrittenSignature from './HandWrittenSignature'
import { observer } from 'mobx-react'
import hocWithBaseElementWrap from '../../utils/hocWithBaseElementWrap/index';
export default hocWithBaseElementWrap(observer(HandWrittenSignature))